import {
  GET_CONTACT,
  GET_CONTACT_SUCCESS,
  GET_CONTACT_FAIL,
  DELETE_CONTACT,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_FAIL,
  UPDATE_CONTACT,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_FAIL,
  ADD_NEW_CONTACT,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACT_FAIL,
  CONTACT_LOADING,
  CONTACT_RESET,
} from "./actionType";

export const resetContactState = (actionType) => ({
  type: CONTACT_RESET,
  payload: { actionType },
});

export const getContactSuccess = (actionType, data) => ({
  type: GET_CONTACT_SUCCESS,
  payload: { actionType, data },
});

export const getContactFail = (actionType, error) => ({
  type: GET_CONTACT_FAIL,
  payload: { actionType, error },
});

export const getContact = (data) => ({
  type: GET_CONTACT,
  payload: data,
});

export const getContactLoading = () => ({
  type: CONTACT_LOADING,
});

export const deleteContact = (data) => ({
  type: DELETE_CONTACT,
  payload: data,
});

export const deleteContactSuccess = (data) => ({
  type: DELETE_CONTACT_SUCCESS,
  payload: data,
});

export const deleteContactFail = (error) => ({
  type: DELETE_CONTACT_FAIL,
  payload: error,
});

export const updateContact = (data) => ({
  type: UPDATE_CONTACT,
  payload: data,
});

export const updateContactFail = (error) => ({
  type: UPDATE_CONTACT_FAIL,
  payload: error,
});

export const updateContactSuccess = (data) => ({
  type: UPDATE_CONTACT_SUCCESS,
  payload: data,
});

export const addNewContact = (data) => ({
  type: ADD_NEW_CONTACT,
  payload: data,
});

export const addContactSuccess = (data) => ({
  type: ADD_CONTACT_SUCCESS,
  payload: data,
});

export const addContactFail = (error) => ({
  type: ADD_CONTACT_FAIL,
  payload: error,
});
